import React from "react";
import { HERO_CONTENT } from "../constants";
import { motion } from "framer-motion";

const container = (delay) => ({
  hidden: { x: -100, opacity: 0 }, // typo fixed
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 0.5, delay: delay },
  },
});

const Hero = () => {
  return (
    <div
      id="about"
      className="border-b bg-zinc-900 border-neutral-800 pb-10 lg:pb-20"
    >
      <div className="flex flex-col lg:flex-row justify-center items-center p-6 md:p-12 lg:p-16 gap-8">
        {/* Left side content */}
        <div className="w-full lg:w-1/2">
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
            <motion.h1
              variants={container(0.5)}
              initial="hidden"
              animate="visible"
              className="pb-8 text-3xl md:text-5xl font-thin tracking-tight hover:underline decoration-violet-500 transition duration-700 ease-in-out"
            >
              Mohamed Mafaz
            </motion.h1>

            <motion.span
              variants={container(1)}
              initial="hidden"
              animate="visible"
              className="bg-gradient-to-r from-pink-300 via-slate-500 to-purple-500 bg-clip-text text-2xl md:text-3xl tracking-tight text-transparent"
            >
              Simulation-AI Engineer
            </motion.span>

            <motion.p
              variants={container(1.5)}
              initial="hidden"
              animate="visible"
              className="mt-4 max-w-lg font-normal text-sm md:text-base text-justify tracking-tight leading-relaxed"
            >
              {HERO_CONTENT}
            </motion.p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Hero;